<script>
import SplitText from '../../utilities/SplitText';
import fadeInUp from '../components/animations/FadeInUp.vue';
import wordsUp from '../components/animations/WordsUp.vue';
import zoomIn from '../components/animations/ZoomIn.vue';
import magnetic from '../components/Magnetic.vue';

export default {
    components: {
        fadeInUp,
        wordsUp,
        zoomIn,
        magnetic
    },

    data() {
        return {
            words: [],
            activeWord: 0,
            delay: 2500,
            totalWords: 0,
            animating: true
        };
    },

    mounted() {
        this.$root.$on('ready', this.wordsInit);
        this.$root.$on('ready', this.parallax);
    },

    methods: {
        wordsInit() {
            const words = document.querySelectorAll('[data-word-slide]');

            [...words].forEach((word, i) => {
                const split = new SplitText(word, {
                    type: 'words, chars'
                });

                gsap.set(word, { perspective: 400 });
                this.words.push([word, split]);
            });

            this.totalWords = this.words.length - 1;

            this.animateIn(this.words[0]);

            // :: Window is NOT in Focus -- Pause Animations ------------ //
            window.addEventListener(
                'blur',
                () => {
                    this.animating = false;
                },
                false
            );

            // :: Window is in Focus -- Resume Animations ------------ //
            window.addEventListener(
                'focus',
                () => {
                    if (!this.animating) {
                        this.animating = true;
                        this.rotationStart(this.words[this.activeWord]);
                    }
                },
                false
            );
        },

        animateIn(word) {
            const tl = gsap.timeline({
                delay: 1.4
            });

            const opening = new SplitText(this.$refs.textStart, { type: 'words' });

            tl.set(word[0], { opacity: 1 })
                .from(opening.words, {
                    y: '100%',
                    opacity: 0,
                    duration: 0.5,
                    stagger: 0.08,
                    ease: 'circ.out'
                })
                .from(
                    word[1].chars,
                    {
                        opacity: 0,
                        y: 50,
                        rotationX: -150,
                        duration: 1,
                        stagger: 0.05,
                        transformOrigin: '0% 50% -50',
                        ease: 'back.inOut',
                        onComplete: () => {
                            setTimeout(() => {
                                this.rotationStart(word);
                            }, 1800);
                        }
                    },
                    '<0'
                )
                .from(this.$refs.entryBackground, { duration: 0.5, x: '-104%', ease: 'circ.out' }, '>-0.4')
                .from(this.$refs.entryWindow, { opacity: 0, duration: 0.5 }, '>-0.1')
                .from(this.$refs.button, { y: '100%', opacity: 0, duration: 0.5, ease: 'circ.out' }, '<-0.2');
        },

        rotationStart(word) {
            if (this.animating) {
                const nextWord = this.nextWord();

                this.animateWords(word, nextWord);

                setTimeout(() => {
                    this.rotationStart(nextWord);
                }, this.delay);
            }
        },

        nextWord() {
            let index;

            if (this.activeWord + 1 <= this.totalWords) {
                index = this.activeWord + 1;
            } else {
                index = 0;
            }

            return this.words[index];
        },

        animateWords(oldWord, newWord) {
            const wordSwim = gsap.timeline();

            this.updateActiveState();

            wordSwim
                .set(newWord[0], { opacity: 1 })
                .to(oldWord[1].chars, {
                    opacity: 0,
                    y: -50,
                    rotationX: 150,
                    duration: 0.8,
                    stagger: 0.05,
                    transformOrigin: '0% 50% -50',
                    ease: 'back.inOut'
                })
                .fromTo(
                    newWord[1].chars,
                    {
                        opacity: 0,
                        y: 50,
                        rotationX: -150
                    },
                    {
                        opacity: 1,
                        y: 0,
                        rotationX: 0,
                        duration: 0.8,
                        stagger: 0.05,
                        transformOrigin: '0% 50% -50',
                        ease: 'back.inOut'
                    },
                    '<0.2'
                );
        },

        updateActiveState() {
            if (this.activeWord + 1 <= this.totalWords) {
                this.activeWord++;
            } else {
                this.activeWord = 0;
            }
        },

        parallax() {
            const parallax = gsap.timeline({
                scrollTrigger: {
                    trigger: this.$refs.container,
                    start: 'top top',
                    end: 'bottom top',
                    scrub: true
                }
            });

            parallax
                .add('start')
                .fromTo(
                    this.$refs.background,
                    {
                        yPercent: 0,
                        scale: 1
                    },
                    {
                        yPercent: 40,
                        scale: 1.1,
                        ease: 'none'
                    }
                )
                .fromTo(
                    this.$refs.content,
                    {
                        yPercent: 0,
                        opacity: 1
                    },
                    {
                        yPercent: -200,
                        opacity: 0,
                        ease: 'none'
                    },
                    'start'
                );
        }
    }
};
</script>
